<template>
    <v-row>
        <v-col cols="6" sm="3" md="3">
            <v-text-field
                v-model="searchProxy"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                dense
            ></v-text-field>
            <v-switch
                v-model="activeProxy"
                :label="activeProxy ? 'Active' : 'Inactive'"
            ></v-switch>
        </v-col>
        <v-col cols="12" sm="12" md="3">
            <v-btn-toggle
              v-model="belowProxy"
              dense
            >
            <v-btn>
                <span class="mr-1">
                    All
                </span>
                <v-icon>mdi-all-inclusive</v-icon>
            </v-btn>
            <v-btn>
                <span class="mr-1">
                    Above threshold
                </span>
                <v-icon>mdi-arrow-collapse-up</v-icon>
            </v-btn>
            <v-btn>
                <span class="mr-1">
                    Below threshold
                </span>
                <v-icon>mdi-arrow-collapse-down</v-icon>
            </v-btn>
            </v-btn-toggle>
            <v-select
                v-model="repeatProxy"
                :items="[{text:'0 - Once',value:0},{text:'1 - Every day', value:1},{text:'2 - Every 2 days', value:2},{text:'3 - Every 3 days',value:3}]"
                label="Repeat every days"
                multiple
                clearable
            ></v-select>
        </v-col>
        <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateProxy"
                  label="Select a date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="dateProxy = null"
                  class="mt-0 pt-0"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateProxy"
                no-title
                scrollable
                @change="$refs.menu.save(date)"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="dateProxy = null;"
                >
                  Clear
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
        </v-col>
    </v-row>
</template>
<script>
export default {
    name: "RemindersFilter",
    props:{
        filters: {type: Object, required: true},
    },
    data() {
        return {
            menu: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().s,
            is_below_threshold: null,
        }
    },
    computed: {
        searchProxy: {
            get() {
                return this.filters.search;
            },
            set(v) {
                this.$emit("update:filters", { ...this.filters, search: v });
            },
        },
        activeProxy:{
            get(){
                return this.filters.active;
            },
            set(v){
                this.$emit("update:filters", { ...this.filters, active: v});
            }
        },
        belowProxy:{
            get(){
                return this.filters.below_threshold;
            },
            set(v){
                this.$emit("update:filters", { ...this.filters, below_threshold: v});
            }
        },
        repeatProxy:{
            get(){
                return this.filters.repeatdays;
            },
            set(v){
                this.$emit("update:filters", { ...this.filters, repeatdays: v});
            }
        },
        dateProxy:{
            get(){
                return this.filters.last_notified_at;
            },
            set(v){
                this.$emit("update:filters", { ...this.filters, last_notified_at: v});
            }
        },
    },
}
</script>